'use client';

import { useCallback, type ReactElement } from 'react';
import { useLocation } from 'react-router';
import type { RefinementProps } from '@/components/eataly-plp-filters/lib/types';
import { EatalyPlpSubcategoryTagLink } from '@/components/eataly-plp-subcategory-tag';
import { applyRefinesToSearchParams, computeNextRefines } from '@/components/eataly-plp-filters/lib/refine-url';
import { PRODUCT_SEARCH_QUERY_PARAMS } from '@/lib/query-params';
import { cn } from '@/lib/utils';

export default function EatalyRefineCategory({
    values,
    attributeId,
    isFilterSelected,
    toggleFilter,
    isPending,
}: RefinementProps): ReactElement {
    const location = useLocation();

    const getRefineUrl = useCallback(
        (value: string) => {
            const params = new URLSearchParams(location.search);
            const currentRefines = params.getAll(PRODUCT_SEARCH_QUERY_PARAMS.REFINE);
            const nextRefines = computeNextRefines(currentRefines, attributeId, value);
            applyRefinesToSearchParams(params, nextRefines);
            const serialized = params.toString();
            return serialized ? `?${serialized}` : '';
        },
        [location.search, attributeId]
    );

    return (
        <div
            className={cn(
                'mt-2 flex flex-wrap gap-2',
                isPending && 'pointer-events-none opacity-50 [&_a]:cursor-default'
            )}>
            {values.map((value) => {
                const isSelected = isFilterSelected(attributeId, value.value);
                return (
                    <EatalyPlpSubcategoryTagLink
                        key={value.value}
                        label={value.label || value.value}
                        isSelected={isSelected}
                        to={getRefineUrl(value.value)}
                        onNavigate={() => toggleFilter(attributeId, value.value)}
                        isCurrentPage={isSelected}
                    />
                );
            })}
        </div>
    );
}
